import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import React, { useEffect, useState } from "react";
import Loader from "react-loaders";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  CustomInput,
  Modal,
  ModalHeader,
  Row,
  Input,
} from "reactstrap";
import swal from "sweetalert";
import { api } from "../../_services/api.service";
import { AppHelper } from "../../_helpers/appHelper";
import exceptionHandler from "../../_helpers/exceptionHandler";

const FieldSettings = ({
  fieldItem,
  showModal,
  toggleModal,
  milestoneTypes,
  reloadList,
}) => {
  let [isLoading, setIsLoading] = useState(false);
  let [isServerProcessing, setIsServerProcessing] = useState(false);
  let [field, setField] = useState(fieldItem);
  let [newDropDownItem, setNewDropDownItem] = useState("");

  useEffect(() => {
    setField(fieldItem)
  }, [fieldItem, showModal]);

  const handleSubmit = async (e, errors, values) => {
    if (errors.length > 0)
      return;

    setIsServerProcessing(true);
    if (field.fieldID === -1) { // create new field
      await api.createField(field)
      .then(created => {
        if (created) toggleModal();
        else AppHelper.showErrorToast();
      })
      .catch(exceptionHandler);
    } else { // update existing field
      await api.updateField(field)
      .then(created => {
        if (created) toggleModal();
        else AppHelper.showErrorToast();
      })
      .catch(exceptionHandler);
    }

    setIsServerProcessing(false);
    reloadList && reloadList();
  };

  const removeField = () => {
    swal({
      text: "Are you sure you want to remove this item?",
      icon: "warning",
      buttons: {
        ok: "Yes",
        cancel: "No",
      },
      dangerMode: true,
    }).then(async (val) => {
      if (val) {
        setIsServerProcessing(true);
        await api.deleteField(field.fieldID)
          .then(deleted => {
            if (deleted) {
              toggleModal();
              reloadList && reloadList();
            } else AppHelper.showErrorToast();
          })
          .catch(exceptionHandler);

        setIsServerProcessing(false);
      }
    });
  };

  const addToDropDownItems = () => {
    if (newDropDownItem === null || newDropDownItem === undefined || newDropDownItem.trim() === "")
      return;

    const a = newDropDownItem.toString().toLowerCase();
    const duplicate = field.fieldOptions.some((item, _) => item.option.toLowerCase() === a);
    if (duplicate) {
      AppHelper.showErrorToast("The Item is already present in the list!");
      return;
    }

    setField({...field, fieldOptions: [...field.fieldOptions, {id: -1, fieldID: field.fieldID, option: newDropDownItem.toString()}]});
    setNewDropDownItem("");
  };

  const removeFromDropDownItems = (item) => {
    let options = field.fieldOptions.filter(o => o.id !== item.id);
    setField({...field, fieldOptions: options});
  }

  const fieldTypes = [
    { value: "ShortText", des: "Short Text" },
    { value: "LongText", des: "Long Text" },
    { value: "Number", des: "Number" },
    { value: "DropDown", des: "DropDown" },
    { value: "List", des: "List" },
    { value: "Currency", des: "Currency" },
    { value: "YesNo", des: "Yes or No" }
  ];

  return (
    <Modal
      size="lg"
      isOpen={showModal}
      toggle={toggleModal}
      backdrop="static"
    >
      <ModalHeader toggle={toggleModal}>{field.fieldName ? field.fieldName : "New"} field</ModalHeader>
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                <AvForm onSubmit={handleSubmit}>
                  <Row>
                    <Col md="12">
                      <AvField
                        name="fieldName"
                        label="Field Name *"
                        value={field.fieldName}
                        onChange={(e) =>
                          setField({
                            ...field,
                            fieldName: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        required
                      />

                      <div className="form-group">
                        <label>Milestone</label>
                        <CustomInput
                          type="select"
                          id={"phaseTypeEditable"}
                          value={field.milestoneID}
                          className="form-control"
                          name={"milestoneTypeEditable"}
                          onChange={(e) => {
                            setField({
                              ...field,
                              milestoneID: e.target.value,
                            })
                          }}
                        >
                          {milestoneTypes.map((x) => {
                            return (
                              <option key={x.id} value={x.id}>
                                {x.name}
                              </option>
                            );
                          })}
                        </CustomInput>
                      </div>

                      <div className="form-group">
                        <label>Field Type</label>
                        <CustomInput
                          type="select"
                          id={"fieldTypeEditable"}
                          value={field.fieldType}
                          className="form-control"
                          name={"fieldTypeEditable"}
                          onChange={(e) => {
                            setField({
                              ...field,
                              fieldType: e.target.value,
                            })
                          }}
                        >
                          {fieldTypes.map((x) => {
                            return (
                              <option key={x.value} value={x.value}>
                                {x.des}
                              </option>
                            );
                          })}
                        </CustomInput>
                      </div>

                      {field.fieldType === "DropDown" && (
                        <div className="form-group">
                          <label>DropDown Items</label>
                          <div>
                            <Row style={{ marginBottom: "10px", paddingRight: "15px" }}>
                              <Col md="8">
                                <Input
                                  type="text"
                                  value={newDropDownItem}
                                  onChange={(e) => setNewDropDownItem(e.target.value)}
                                />
                              </Col>
                              <Col md="4">
                                <Button
                                  color="primary"
                                  style={{ display: "inline-block" }}
                                  onClick={addToDropDownItems}
                                >
                                  Add to list
                                </Button>
                              </Col>
                            </Row>
                            <ul>
                              {field.fieldOptions &&
                                field.fieldOptions.map((item, i) => {
                                  return <li className="list-item" key={field.fieldName + item.option + i}>{item.option}
                                    <i
                                      className="fa fa-times-circle "
                                      style={{
                                        color: 'RED',
                                        fontSize: "15px",
                                        cursor: "pointer",
                                        paddingLeft: "10px",
                                        paddingTop: "5px",
                                      }}
                                      onClick={() => removeFromDropDownItems(item)}
                                    />
                                  </li>;
                                })}

                              {(!field.fieldOptions || field.fieldOptions.length === 0) && (
                                <p>There are no items for this dropdown. Add items using "Add to list" button</p>
                              )}
                            </ul>
                          </div>
                        </div>
                      )}

                      <AvField
                        name="fieldLabel"
                        label="Question"
                        value={field.fieldLabel}
                        onChange={(e) =>
                          setField({
                            ...field,
                            fieldLabel: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="instructions"
                        label="Instructions"
                        value={field.instructions}
                        onChange={(e) =>
                          setField({
                            ...field,
                            instructions: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <div className="form-group">
                        <CustomInput
                          readOnly={true}
                          type="checkbox"
                          id={`field-${field.fieldID}`}
                          checked={field.mandatory}
                          label="Mandatory"
                          onChange={(e) => {
                            setField({
                              ...field,
                              mandatory: e.target.checked,
                            })
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label>Points</label>
                        <Input
                          type="number"
                          value={field.points}
                          onChange={(e) => {
                            let val = e.target.value;
                            if (
                              e.target.value != null &&
                              e.target.value.indexOf(".") !== -1
                            ) {
                              val = e.target.value.split(".")[0];
                            }
                            setField({ ...field, points: val });
                          }
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label>Add Alternative or Objective</label>
                        <CustomInput
                          type="select"
                          id={"addAltObj"}
                          value={field.addAltObj}
                          className="form-control"
                          name={"addAltObj"}
                          onChange={(e) => {
                            setField({
                              ...field,
                              addAltObj: e.target.value,
                            })
                          }}
                        >
                          {[{value: "NA", des:"NA"}, {value: "AddAlt", des:"Alternative"}, {value: "AddObj", des:"Objective"}].map((x) => {
                            return (
                              <option key={x.value} value={x.value}>
                                {x.des}
                              </option>
                            );
                          })}
                        </CustomInput>
                      </div>

                      {(field.addAltObj === "AddAlt" || field.addAltObj === "AddObj") &&
                        <AvField
                          name="addQuestion"
                          label="Add Question *"
                          value={field.addQuestion}
                          onChange={(e) =>
                            setField({
                              ...field,
                              addQuestion: e.target.value,
                            })
                          }
                        placeholder="Enter..."
                        required
                      />}

                      {(field.addAltObj === "AddAlt" || field.addAltObj === "AddObj") &&
                        <AvField
                          name="altObjName"
                          label="Add Alternative or Objective Name *"
                          value={field.altObjName}
                          onChange={(e) =>
                            setField({
                              ...field,
                              altObjName: e.target.value,
                            })
                          }
                        placeholder="Enter..."
                        required
                      />}
                    </Col>

                  </Row>
                  <div className="pull-right">
                    {isServerProcessing && <Loader style={{}} type="ball-pulse" active />}
                    <Button
                      color="primary"
                      type="submit"
                      style={{ marginRight: ".25rem" }}
                      disabled={isServerProcessing}
                    >
                      Save
                    </Button>
                    {field.milestoneID !== -1 && <Button disabled={isServerProcessing} color="danger" onClick={() => removeField()}>
                      Delete
                    </Button>}
                    <Button
                      color="link"
                      className="pull-right"
                      onClick={() => toggleModal()}
                    >
                      Cancel
                    </Button>
                  </div>
                </AvForm>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Modal>
  );
};

FieldSettings.propTypes = {
  fieldItem: PropTypes.shape({
    fieldID: PropTypes.number,
    fieldName: PropTypes.string,
    fieldType: PropTypes.oneOf(['ShortText', 'LongText', 'Number', 'DropDown', 'List', 'Currency', 'YesNo']),
    orderID: PropTypes.number,
    milestoneID: PropTypes.number,
    fieldLabel: PropTypes.string,
    instructions: PropTypes.string,
    mandatory: PropTypes.bool,
    points: PropTypes.number,
    addAltObj: PropTypes.oneOf(['NA', 'Alternative', 'Objective']),
    addQuestion: PropTypes.string,
    altObjName: PropTypes.string,
    fieldOptions: PropTypes.array,
  }),
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  reloadList: PropTypes.func,
};

FieldSettings.defaultProps = {
  fieldItem: {
    fieldID: -1,
    fieldName: "",
    orderID: -1,
    milestoneID: 0,
    fieldType: "ShortText",
    fieldLabel: "",
    instructions: "",
    mandatory: false,
    points: 0,
    addAltObj: "NA",
    addQuestion: "",
    altObjName: "",
    fieldOptions: [],
  },
  showModal: false
};

export default FieldSettings;